import { Link } from "react-router-dom";
import Logo from "../assets/logo.png"

export default function SiteFooter() {
    return (
        <footer className="border-t hairline" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 flex flex-col md:flex-row md:items-end justify-between gap-10">
                <div>
                    <div className="flex items-center">
                        <img src={Logo} alt="femipalLogo" className="w-[40px]" />
                        <span className="font-serif-display text-3xl font-semibold tracking-tight">Femipal</span>
                    </div>
                    <p className="text-sm text-[#D1C6DF] max-w-xs leading-relaxed">
                        Healthcare that understands her
                    </p>
                </div>
                <div className="flex flex-col gap-3 md:text-right">
                    <Link
                        to="/legal"
                        data-testid="footer-legal-link"
                        className="overline-label text-[#D1C6DF] hover:text-[#F7F3FA] transition-colors duration-300"
                    >
                        Legal Documents
                    </Link>
                    <span className="overline-label text-[#8F82A2]">© 2026 Femipal</span>
                </div>
            </div>
        </footer>
    );
}